import { TextField, Typography } from '@mui/material';
import { UseFormRegisterReturn } from 'react-hook-form';

type CampaignNameEditorProps = {
  register: UseFormRegisterReturn;
};

export const CampaignNameEditor = (props: CampaignNameEditorProps) => {
  const { register } = props;

  return (
    <>
      <Typography component="h6" variant="h6">
        Campaign Name
      </Typography>
      <TextField
        {...register}
        id="campaignName"
        name="campaignName"
        inputRef={register.ref}
        sx={{ width: '48%' }}
        label="Campaign Name"
        inputProps={{ maxLength: 160 }}
      />
    </>
  );
};
